import {
  buildTimerUserStateRecord,
  extractLegacyTimerAnswerState,
  extractTimerUserState,
  timerUserStateLocator,
  type TimerAnswerState,
} from "#bb/lib/timer";

export function useTimerStateStorage() {
  const storage = useUserStateStorage();
  const { getAnswer } = useAnswers();
  const { getResolvedDataPath } = useContentManager();

  async function load(blockId: string): Promise<unknown> {
    const dataPath = getResolvedDataPath(blockId);
    const record = await storage.load(timerUserStateLocator(dataPath, blockId));
    if (record) {
      return extractTimerUserState(record);
    }
    return extractLegacyTimerAnswerState(
      await getAnswer(blockId, dataPath.join("/")),
    );
  }

  async function save(blockId: string, state: TimerAnswerState): Promise<void> {
    const dataPath = getResolvedDataPath(blockId);
    await storage.save(
      timerUserStateLocator(dataPath, blockId),
      buildTimerUserStateRecord(dataPath, blockId, state),
    );
  }

  return { load, save };
}
